export default {
  menu: {
    homepage: '首页',
    home: '首页',
    faq: '常见问题',
    arcoWebsite: 'Arco 官网',
    organization: {
      title: '组织架构',
      company: '公司',
      department: '部门',
      departmentEdit: '部门编辑',
      user: '用户',
      userDetail: '用户详情',
    },
    application: '应用中心',
    discover: {
      title: '发现',
      appMarket: '应用市场',
      toolMarket: '工具市场',
      toolDetail: '工具详情',
    },
    develop: {
      title: '开发',
      scheduler: '定时任务',
      workflow: {
        title: '工作流',
        index: '我的工作流',
        detail: '工作流详情',
        execution: '执行记录',
        executionDetail: '执行详情',
      },
      evaluation: {
        title: '评测与成本',
        datasets: '评测集管理',
        experiments: '实验管理',
        cost: '成本治理',
      },
      tool: {
        title: '工具',
        index: '我的工具',
      },
      configuration: '配置',
    },
    deploy: {
      title: '部署',
      database: {
        title: '数据库',
        mysql: 'MySQL',
        postgres: 'Postgres',
        milvus: 'Milvus',
      },
      knowledge: {
        title: '知识库',
        knowledge: '知识库',
        knowledgeDetail: '知识库详情',
        knowledgeBaseDetail: '知识库详情',
        knowledgeDocumentDetail: '知识库文档详情',
      },
      apps: 'Worker',
    },
    contact: '联系我们',
    config: '配置中心',
    document: '文档中心',
    evaluation: {
      title: '评测管理',
      experiments: '效果评测',
      create: '创建实验',
      edit: '编辑实验',
      detail: '实验详情',
    },
    protocol: {
      title: '执行标识管理',
      create: '创建执行标识',
      bind: '绑定工作流',
    },
    template: '资源模板',
    changelog: '更新日志',
  },
};
